import { updateGroupsApi } from 'common/api/settings';
import { toast } from 'react-toastify';
import i18next from 'i18next';

/**
 * @param {startChannels: StartChannel[]} payload
 * @return {IterableIterator<*>}
 */
export function* updateStartChannelsEffect({ payload }) {
  try {
    yield updateGroupsApi(payload.startChannels);
    yield toast.success(i18next.t('policies_has_been_saved'));
  } catch (error) {}
}
